module.exports = __webpack_public_path__ + "static/media/world-map.070764b2.png";